import React from 'react';
import { CaseStudyCard } from './CaseStudyCard';
export function CaseStudies() {
  const caseStudies = [{
    title: 'Reimagining Healthcare Scheduling',
    category: 'Healthcare / Mobile App',
    description: 'A complete redesign of the patient booking experience that reduced appointment no-shows by 34% and improved clinic efficiency.',
    imageColor: '#E8F0EE',
    tags: ['UX Research', 'Mobile Design', 'Prototyping']
  }, {
    title: 'Simplifying Enterprise Onboarding',
    category: 'SaaS / B2B',
    description: 'Streamlining a complex 14-step configuration process into an intuitive guided flow, cutting onboarding time from 2 weeks to 3 days.',
    imageColor: '#F0EBE1',
    tags: ['Systems Design', 'User Testing', 'Web App']
  }, {
    title: 'Designing for Financial Literacy',
    category: 'Fintech / Consumer',
    description: 'Creating an accessible, engaging educational platform that demystifies personal finance and increased daily user engagement by 58%.',
    imageColor: '#E6EBF0',
    tags: ['Product Strategy', 'UI Design', 'Design System']
  }];
  return <section id="work" className="py-24 md:py-32 px-6 md:px-12 max-w-7xl mx-auto" data-id="element-18">
      <div className="mb-16 md:mb-24 flex flex-col md:flex-row md:items-end justify-between gap-8" data-id="element-19">
        <div data-id="element-20">
          <h2 className="font-serif text-4xl md:text-5xl text-text mb-4" data-id="element-21">
            Selected Work
          </h2>
          <p className="font-sans text-text-muted text-lg max-w-xl" data-id="element-22">
            A collection of recent projects focusing on complex problem solving
            and intuitive user experiences.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 md:gap-8" data-id="element-23">
        {caseStudies.map((study, index) => <CaseStudyCard key={index} title={study.title} category={study.category} description={study.description} imageColor={study.imageColor} tags={study.tags} data-id="element-24" />)}
      </div>
    </section>;
}